export default __webpack_public_path__ + "static/media/darya2.7528570e.jpeg";